module.exports = __webpack_public_path__ + "img/customer-lyalty-depth.1f7a2581.webp";